export default __webpack_public_path__ + "sort-by-alphabet.png";